import type { IconProps } from '.';

/**
 * Facebook Icon SVG component.
 *
 * IMPORTANT:
 * Importing a SVG directly tells the compiler to use Webpack, thus including the whole file in the bundle.
 * By using a component instead, we can leverage server components and return HTML directly from the server.
 */

const FacebookIcon = ({ className }: IconProps) => (
  <svg
    role="presentation"
    aria-hidden="true"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 18 18"
    fill="none"
    className={className}
  >
    <path
      d="M17.7188 9.05273C17.7188 13.4121 14.5195 17.0332 10.3359 17.666V11.584H12.375L12.7617 9.05273H10.3359V7.43555C10.3359 6.73242 10.6875 6.06445 11.7773 6.06445H12.8672V3.91992C12.8672 3.91992 11.8828 3.74414 10.8984 3.74414C8.92969 3.74414 7.62891 4.97461 7.62891 7.1543V9.05273H5.41406V11.584H7.62891V17.666C3.44531 17.0332 0.28125 13.4121 0.28125 9.05273C0.28125 4.23633 4.18359 0.333984 9 0.333984C13.8164 0.333984 17.7188 4.23633 17.7188 9.05273Z"
      fill="white"
    />
  </svg>
);

export default FacebookIcon;
